module.exports = __webpack_public_path__ + "static/img/gif.e2386478.png";